import ToastMessage from './ToastMessage.component';

export default ToastMessage;
